import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { Header } from '../index'
import {
  appstorewhitebtn,
  googlewhitebtn,
  brandlogowhite,
  brandlogo,
} from '../../assets'
import styles from './fitnesshero.module.css'

const Fitnesshero = () => {
  return (
    <div className={styles.firstFrame}>
      <Header
        brand={brandlogowhite}
        linkStyles={styles.linkStyles}
        mobileBrand={brandlogo}
        brandToggle={brandlogo}
      />
      <div className={styles.firstFramewrapper}></div>
      <div className={styles.estateheaderBody}>
        <div className={styles.headerBodyleft}>
          <div className={styles.usecase}>Fitness</div>
          <div className={styles.headerBodylefttextsbuttons}>
            <div className={styles.headerBodylefttexts}>
              <p className={styles.toplefttext}>
                Manage your gym membership and access control easily
              </p>
              <p className={styles.bottomlefttext}>
                CirclePlug offers all the tools you need to manage every aspect
                of your fitness process every step of the way
              </p>
            </div>
            <div className={styles.platformbuttons}>
              <Link
                target={'_blank'}
                className={styles.platformbutton}
                href={`https://apps.apple.com/ng/app/circleplug/id6462672418`}
              >
                <Image src={appstorewhitebtn} alt='app store button' />
              </Link>
              <Link
                target={'_blank'}
                className={styles.platformbutton}
                href={`https://play.google.com/store/apps/details?id=com.shypes.circlePlug`}
              >
                <Image src={googlewhitebtn} alt='google play button' />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Fitnesshero
